<template>
  <div class="container logged-out-content">
    <form class="block form-sm" @submit.prevent="requestRemoval()">
      <header>
        <div class="pull-left">
          <div class="icon">
            <img src="~assets/images/Patient-Icon.png">
          </div>
        </div>
        <div class="col-xs-9">
          <h2>Delete your profile</h2>
        </div>
      </header>

      <div v-if="loading" class="container-fluid spinner-container">
        <div class="row">
          <div class="col-xs-12 primary">
            <i class="glyphicon glyphicon-refresh glyphicon-refresh-animate slow-large-refresh-animate"></i>
          </div>
        </div>
      </div>
      <div v-else-if="validToken" class="content text-bold h5" style="overflow: auto;">
        <p>Please take note of the following process applicable to the deletion of your profile:</p>
        <p>The HPCSA guidelines states that “Health records should be stored for a period of not less than six (6) years as from the date they became dormant”.</p>
        <p>On submission of this form, your user account will be removed and your personal information will be ‘archived’ making it inaccessible via the LogBox
          system and unsubscribing from all email communication to your email address</p>
        <br/>
        <submit-button :loading="loadingRequest">Submit Request</submit-button>
      </div>
      <div v-else class="content h5">
        PLEASE NOTE:<br/><br/>
        Requests for the removal of patient account details can be done via the <a href="https://play.google.com/store/apps/details?id=logbox.co.za.unified_demographics">LogBox Patient application</a>.<br/><br/>
        Please download the application from the <a href="https://play.google.com/store/apps/details?id=logbox.co.za.unified_demographics">Google play</a> or <a href="https://apps.apple.com/za/app/logbox-patient/id1101708807">Apple store</a> and submit a request using the account settings.<br/><br/>

      </div>
    </form>
  </div>
</template>

<script>

import SubmitButton from '../common/buttons/SubmitButton';

export default {
  name: 'request-removal',
  components: { SubmitButton },
  data: () => ({
    token: null,
    validToken: false,
    loading: true,
    requestingUser: {},
    loadingRequest: false,
  }),
  async mounted() {
    this.token = this.$route.params.token;
    this.$api.validateAccountDeletionToken(this.token).then((response) => {
      this.validToken = true;
      this.requestingUser = response;
    }).catch(() => {
      this.validToken = false;
    }).finally(() => {
      this.loading = false;
    });
  },
  methods: {
    async requestRemoval() {
      this.loadingRequest = true;
      await this.$api.deleteAccount(this.requestingUser.userId, this.token).then(() => {
        this.$router.push({ name: 'Patient' });
      }).catch(() => {
        this.loadingRequest = false;
      });
    },
  },
};

</script>



// WEBPACK FOOTER //
// RequestRemoval.vue?307ddc98